import cx from 'classnames';
import React, { ReactNode } from 'react';

import './spec-course-lesson-view.scss';

interface Props {
    children: ReactNode | ReactNode[];
    mix?: string;
}

export const SpecCourseLessonView = ({ children, mix }: Props) => {
    return <div className={cx('spec-course-lesson-view', mix)}>{children}</div>;
};
